import { render, staticRenderFns } from "./RoomManagement.vue?vue&type=template&id=4474922f&scoped=true&"
import script from "./RoomManagement.vue?vue&type=script&lang=js&"
export * from "./RoomManagement.vue?vue&type=script&lang=js&"
import style0 from "./RoomManagement.vue?vue&type=style&index=0&id=4474922f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4474922f",
  null
  
)

export default component.exports